import React, { useState } from 'react';
import styles from './styles.module.scss';

const InviteStaffModal = ({ 
    isOpen, 
    onClose, 
    onInvite, 
    currentUserRole,
    loading,
    error
}) => {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('STAFF');
    const [title, setTitle] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email.trim()) {
            onInvite({
                email: email.trim(),
                role,
                title: title.trim() || undefined
            });
        }
    };

    const handleClose = () => {
        setEmail('');
        setRole('STAFF');
        setTitle('');
        onClose();
    };

    if (!isOpen) return null;

    // Determine available roles based on current user's role
    let availableRoles = [];
    if (currentUserRole === 'OWNER') {
        availableRoles = [
            { value: 'OWNER', label: 'Owner' },
            { value: 'ADMIN', label: 'Admin' },
            { value: 'STAFF', label: 'Staff' }
        ];
    } else if (currentUserRole === 'ADMIN') {
        availableRoles = [
            { value: 'STAFF', label: 'Staff' }
        ];
    } else {
        // Default case for STAFF role or undefined currentUserRole
        // STAFF members typically cannot invite other staff, so provide empty array
        // but ensure it's explicitly handled to prevent downstream issues
        availableRoles = [];
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2>Invite Staff Member</h2>
                    <button 
                        className={styles.closeButton}
                        onClick={handleClose}
                        type="button"
                    >
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className={styles.content}>
                        {error && (
                            <div className={styles.errorMessage}>
                                {error}
                            </div>
                        )}
                        <div className={styles.field}>
                            <label htmlFor="email">Email Address</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter email address"
                                required
                                disabled={loading}
                            />
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="role">Role</label>
                            <select
                                id="role"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                disabled={loading}
                            >
                                {availableRoles.map((roleOption) => (
                                    <option key={roleOption.value} value={roleOption.value}>
                                        {roleOption.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="title">Title (Optional)</label>
                            <input
                                id="title"
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="e.g., Head Coach, Assistant Coach"
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <div className={styles.footer}>
                        <button 
                            type="button" 
                            className={styles.cancelButton}
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className={styles.inviteButton}
                            disabled={loading || !email.trim()}
                        >
                            {loading ? 'Sending...' : 'Send Invite'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default InviteStaffModal;